"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  castFromTyped: () => castFromTyped,
  castToTyped: () => castToTyped,
  defineArrayMember: () => defineArrayMember,
  defineConfig: () => defineConfig,
  defineField: () => defineField,
  definePlugin: () => definePlugin,
  defineType: () => defineType,
  referenced: () => referenced
});
module.exports = __toCommonJS(src_exports);

// src/internal.ts
var import_sanity = require("sanity");
var referenced = Symbol("referenced");
var makeDefineArrayMember = () => (arrayOfSchema, defineOptions) => (0, import_sanity.defineArrayMember)(
  arrayOfSchema,
  defineOptions
);
var defineArrayMember = makeDefineArrayMember();
var defineField = (schemaField, defineOptions) => (0, import_sanity.defineField)(schemaField, defineOptions);
var defineType = (schemaDefinition, defineOptions) => (0, import_sanity.defineType)(
  schemaDefinition,
  defineOptions
);
var definePlugin = (arg) => (0, import_sanity.definePlugin)(arg);
var defineConfig = (config) => (0, import_sanity.defineConfig)(config);
var castToTyped = (untyped) => untyped;
var castFromTyped = (typed) => typed;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  castFromTyped,
  castToTyped,
  defineArrayMember,
  defineConfig,
  defineField,
  definePlugin,
  defineType,
  referenced
});
